import React from "react";

const WealthProText = ({ className, ...rest }) => {
    return (
        <p className={`text-xxs leading-none text-slate-500 ${className ? className : ''}`} {...rest}>
            Powered by WealthPro. © 2025 Shackleton - Britain's Financial adviser. All right reserved.
        </p>
    );
};

export default WealthProText;